import React from 'react';
import Immutable from 'immutable';

import { Taxonomy } from '@uncinc/react-drupal-core';
import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';

import { TaxonomyGeneric } from '../../../types/uncinc_profile/taxonomy';

interface ProjectTypesOverviewProps {
  entities: Immutable.List<ImmutableEntity<TaxonomyGeneric>>;
}

const ProjectTypesOverview: React.FC<ProjectTypesOverviewProps> = ({ entities }) => (
  <div className="ProjectTypesOverview row">
    {
      entities.map((entity) => {
        const id = entity.getIn(['nid', 0, 'value']);
        const uuid = entity.getIn(['uuid', 0, 'value']);
        const langcode = entity.getIn(['langcode', 0, 'value']);
        const key = `${uuid}:${langcode}`;

        return (
          <Taxonomy
            id={id}
            key={key}
            entity={entity}
            viewMode="teaser"
          />
        );
      })
    }
  </div>
);

export default ProjectTypesOverview;
